module.exports = __webpack_public_path__ + "static/yellow_musk_creeper-367a5ad5c9588b86429e4162dfb48205.png";